export default loadSlider;

// sliders
function slidersInit() {

    // Default slider
    const sliders = $('.slider').not('.slick-initialized');
    sliders.each(function() {
        const slide_to_show = $(this).data('slides');
        $(this).slick({
            infinite: false,
            dots: true,
            margin: 10,
            speed: 300,
            slidesToShow: slide_to_show ? slide_to_show : 3,
            slidesToScroll: slide_to_show ? slide_to_show : 3,
            responsive: [
                // {
                //     breakpoint: 768,
                //     settings: 'unslick'
                // },
                {
                    breakpoint: 1279,
                    settings: {
                        slidesToShow: slide_to_show ? slide_to_show : 3,
                        slidesToScroll: slide_to_show ? slide_to_show : 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 448,
                    settings: {
                        slidesToShow: slide_to_show ? 2 : 1,
                        slidesToScroll: slide_to_show ? 2 : 1,
                    }
                },
            ],
        });
        $(this).find('.slick-dots').wrap('<div class="slider__controls"></div>');
        $(this).find('.slick-prev').prependTo($(this).find('.slider__controls'));
        $(this).find('.slick-next').appendTo($(this).find('.slider__controls'));
    })
}

// slider init
function loadSlider() {
   const sliders = document.querySelectorAll('.is-loading');

   sliders.forEach(slider => slider.classList.remove('is-loading'));
   slidersInit();
}

window.addEventListener('resize', loadSlider);


//////////////////
// WEBPACK FOOTER
// ./js/slider.js
// module id = 6
// module chunks = 0